// take_picture rule photos - web implementation.
//
// The packer picks an image file, which is resized/compressed to JPEG
// through a canvas, then PUT straight to S3 with the presigned URL from
// the worker.
const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.7;

async function compressImage(file) {
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));

  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(bitmap.width * scale));
  canvas.height = Math.max(1, Math.round(bitmap.height * scale));
  canvas.getContext('2d')?.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('Could not compress the image'))),
      'image/jpeg',
      JPEG_QUALITY
    );
  });
}

// Returns the compressed image as a JPEG blob, or null when the user
// cancels the file picker
export async function acquirePackingPhoto() {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        resolve(null);
        return;
      }
      compressImage(file)
        .then((blob) => resolve({ blob, fileName: file.name }))
        .catch(reject);
    };
    input.click();
  });
}

export async function uploadPackingPhoto(uploadUrl, photo) {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': 'image/jpeg' },
    body: photo.blob,
  });

  if (!response.ok) {
    throw new Error(`Photo upload failed with status ${response.status}`);
  }
}
